import { render, staticRenderFns } from "./AIAssitant.vue?vue&type=template&id=4b648ce8&scoped=true"
import script from "./AIAssitant.vue?vue&type=script&lang=js"
export * from "./AIAssitant.vue?vue&type=script&lang=js"
import style0 from "./AIAssitant.vue?vue&type=style&index=0&id=4b648ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b648ce8",
  null
  
)

export default component.exports